import { render, staticRenderFns } from "./FTPClientTest.vue?vue&type=template&id=788a5b44&"
import script from "./FTPClientTest.vue?vue&type=script&lang=js&"
export * from "./FTPClientTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports